// extracted by mini-css-extract-plugin
export default {"root":"style_root__izIRa","header":"style_header__yM4Y7","skeleton":"style_skeleton__7pZLl"};